import { PubSub } from '@instinet-analytics/core-lib';

export interface YAxisMouseOverState {
    x?: number;
    y?: number;
    text?: string;
}

export class YAxisMouseOver extends PubSub<YAxisMouseOverState> {}
